'use client';

import useEmblaCarousel from 'embla-carousel-react';
import type { WaysToHelpContentItem } from '@jlg-website/database/types';
import { WaysToHelpServer } from './server';

export default function WaysToHelpClient({ items }: { items: WaysToHelpContentItem[] }) {
  const [emblaRef] = useEmblaCarousel({
    align: 'center',
    startIndex: 1,
    containScroll: false,
  });

  return <WaysToHelpServer items={items} emblaRef={emblaRef} />;
}
